<template>
  <section id="intro">
    <v-parallax dark="dark" src="@/assets/img/bghero1.jpg" height="750">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" xl="8">
              <h1 class="display-1 font-weight-bold mt-5">
                SKY+ Tutorial for Course Registration
              </h1>
              <h3 class="font-weight-light mt-5">
                SKY+ is the next-generation SKY system for MUIC students. The
                registration process on SKY+ will be brand new. This tutorial
                will guide you through SKY+ and prepare you for the upcoming
                registration in Term 1/2024&ndash;2025.
              </h3>
              <v-alert
                class="mt-2 mb-0"
                v-if="checkVerifyTest === 'yes' || verifyMsg === 'yes'"
                dense
                text
                icon="mdi-shield-check"
                type="success"
              >
                You have <strong>passed</strong> the tutorial.
              </v-alert>
              <!-- -->
              <v-btn
                rounded="rounded"
                outlined="outlined"
                large="large"
                dark="dark"
                @click="$vuetify.goTo('#download')"
                class="mt-5"
              >
                Get Started
                <v-icon class="ml-2">mdi-arrow-down</v-icon>
              </v-btn>
              <div id="my-play-btn">
                <!-- <div class="videoWrapper mt-4"><youtube :video-id="videoId"></youtube></div> -->
                <div class="video d-flex align-center py-4">
                  <a @click.stop="dialog = true" class="playBut">
                    <span>
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
                        x="0px"
                        y="0px"
                        width="60px"
                        height="60px"
                        viewBox="0 0 213.7 213.7"
                        enable-background="new 0 0 213.7 213.7"
                        xml:space="preserve"
                      >
                        <polygon
                          class="triangle"
                          id="XMLID_18_"
                          fill="none"
                          stroke-width="7"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                          points="73.5,62.5 148.5,105.8 73.5,149.1 "
                        />
                        <circle
                          class="circle"
                          id="XMLID_17_"
                          fill="none"
                          stroke-width="7"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                          cx="106.8"
                          cy="106.8"
                          r="103.3"
                        />
                      </svg>
                    </span>
                  </a>
                  <p class="subheading ml-2 mb-0">Watch Video</p>
                </div>
              </div>
            </v-col>
            <!-- mobileframe -->
            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down">
              <youtube :video-id="videoId"></youtube>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
    <v-container fluid="fluid" id="download" class="mt-2">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="5">
              <h2 class="font-weight-bold display-2">
                Download <span class="text-purple">SKY+</span> Mobile
                Application
              </h2>
              <h3 class="font-weight-light mt-5 mb-3">
                SKY+ is mobile-centric. This means you will interact with it on
                your mobile device for best experience. To begin, download the
                <strong>SKY+ application</strong> from App Store (iOS) or Google
                PlayStore (Android) using the QR code provided here.
              </h3>
              <h3 class="font-weight-light mt-5 mb-5">
                With SKY+ application, you can:
              </h3>
              <!-- <v-divider class="my-5"></v-divider> -->
              <v-row>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/calendar.png"
                    max-width="55px"
                    class="mr-4"
                  />
                  <p class="text-justify">
                    Access your schedule and your academic records.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/mobile-payment.png"
                    max-width="55px"
                    class="mr-4"
                  />
                  <p class="text-justify">
                    Register for courses and make payments.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/megaphone.png"
                    max-width="55px"
                    class="mr-4"
                  />
                  <p class="text-justify">View class announcements</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4">
              <div class="text-center">
                <h2>MUIC Sky for Students</h2>
              </div>
              <div class="mt-2 mb-0 text-center">
                <v-avatar class="profile" color="grey" size="150" tile>
                  <v-img src="@/assets/img/app_qr_all.jpg"></v-img>
                </v-avatar>
              </div>
              <div class="text-center">
                <v-btn
                  class="mt-3 mb-2 mr-3"
                  dark="dark"
                  elevation="3"
                  outlined="outlined"
                  color="black"
                  plain="plain"
                  raised="raised"
                  x-large="x-large"
                  target="_blank"
                  href="https://apps.apple.com/th/app/muic-sky-for-students/id1531991012?l=th"
                >
                  <v-icon class="mr-3" large="large" left="left">
                    mdi-apple
                  </v-icon>
                  <span class="text-left">
                    <small class="font-weight-light d-block text-dark"
                      >Available on the</small
                    >
                    App Store
                  </span>
                </v-btn>
                <v-btn
                  class="mt-3 mb-2 mr-3"
                  dark="dark"
                  elevation="3"
                  outlined="outlined"
                  color="black"
                  plain="plain"
                  raised="raised"
                  x-large="x-large"
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=whiz.muic.uspark.student.android"
                >
                  <v-icon class="mr-3" large="large" left="left">
                    mdi-android
                  </v-icon>
                  <span class="d-inline-block text-left">
                    <small class="font-weight-light d-block"
                      >Get it on the</small
                    >
                    Google Play
                  </span>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-row align="start" justify="center">
                <v-col cols="12" md="6" xl="6" class="hidden-sm-and-down">
                  <mobileframe
                    styleMobile="right: 20%"
                    title="Login"
                    name="bg-login"
                  ></mobileframe>
                  <!-- <div class="book-container">
                    <div class="book">
                      <mobileframe
                        styleMobile="right: 20%"
                        title="Login"
                        name="bg-login"
                      ></mobileframe>
                    </div>
                  </div> -->
                </v-col>
                <!-- <v-col cols="12" md="6" xl="6" class="hidden-sm-and-down">
                  <div class="book-container-2">
                    <div class="book-2">
                      <mobileframe
                        styleMobile="left: -100px"
                        title="Login"
                        name="bg-app"
                      ></mobileframe>
                    </div>
                  </div>
                </v-col> -->
              </v-row>
            </v-col>
          </v-row>
          <div class="mb-2 text-center">
            <v-btn
              color="blue darken-4"
              dark
              @click="$vuetify.goTo('#reg-steps')"
            >
              Begin the tutorial
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- btn qr -->
      <v-row id="reg-steps" align="center" justify="center">
        <v-col cols="10">
          <h1 class="text-center pt-6 font-weight-bold display-2">
            New Registration Steps
          </h1>
          <h3 class="text-center font-weight-light mt-5 mb-3">
            SKY+ comes with a new registration process that consists of the
            following 3 steps.
          </h3>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="space-around">
            <v-col
              cols="12"
              sm="4"
              class="text-center"
              v-for="(feature, i) in features"
              :key="i"
            >
              <v-card class="card" shaped="shaped">
                <v-img
                  :src="feature.img"
                  max-width="100px"
                  class="d-block ml-auto mr-auto"
                ></v-img>
                <h1 class="font-weight-regular">{{ feature.title }}</h1>
                <h4 class="font-weight-regular subtitle-1">
                  {{ feature.text }}
                </h4>
              </v-card>
            </v-col>
          </v-row>
          <div class="mt-8 mb-3 text-center">
            <v-btn
              color="blue darken-4"
              dark
              @click="$vuetify.goTo('#step-one')"
            >
              Next Step
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" max-width="640px">
      <v-card>
        <div class="videoWrapper">
          <youtube
            :video-id="videoId"
            @ready="ready"
            @playing="playing"
          ></youtube>
        </div>
      </v-card>
    </v-dialog>
    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
import mobileframe from "@/components/shared/MobileFrame";
export default {
  props: {
    verifyMsg: String,
  },
  components: {
    mobileframe,
  },
  data() {
    return {
      dialog: false,
      videoId: "SziwZZosLE8",
      features: [
        {
          img: require("@/assets/img/step1.png"),
          title: "Plans",
          text: "Prepare courses and sections you want to take.",
        },
        {
          img: require("@/assets/img/step2.png"),
          title: "Submit",
          text: "Submit your entire pre-made plan. No need to register one by one.",
        },
        {
          img: require("@/assets/img/step3.png"),
          title: "Pay",
          text: "Choose a payment method and make payment online.",
        },
      ],
      checkVerifyTest: "",
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
  mounted() {
    // this.checkAnswer();
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change. If you would like to
      // change `playerVars`, please change it before you change `videoId`. If
      // `playerVars.autoplay` is 1, `loadVideoById` will be called. If
      // `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    async checkAnswer() {
      this.checkVerifyTest = "";
      try {
        const res = await this.$http.get(`/sky-training/user/`);
        if (res.status === 200) {
          this.checkVerifyTest = res.data.answer !== null ? "yes" : "no";
        } else {
          throw { res };
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss">
.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}
.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  -webkit-transition: all 0.5s ease;
  .triangle {
    -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }
  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }
    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
.btn-play {
  transition: 0.2s;
}
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
#intro {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}
.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}
.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}
.card h1 {
  margin-bottom: 10px;
}
.zoom-efect {
  transform: scale(1.1);
}
.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
section {
  position: relative;
}
.text-purple {
  color: #4a1480;
}
#my-play-btn { display: none; }
@media screen and (min-width: 0px) and (max-width: 950px) {
  #my-play-btn { display: block; }
}
.videoWrapper {
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	padding-top: 25px;
	height: 0;
}
.videoWrapper iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>